<template>
    <div class="container mx-auto px-4">
        <h1 class="font-serif mb-8 md:text-5xl text-2xl text-center">{{ __('Jelszó módosítása') }}</h1>

        <c-control-text class="mx-auto text-center w-96" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="password" placeholder="**********" required type="password"
                        v-bind:invalid="!!requestStore.errors?.password"
                        v-bind:label="__('New password')"
                        v-model="password"
        />

        <c-control-text class="mt-8 mx-auto text-center w-96" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base w-96" class-label="mb-2" name="password_confirmation" placeholder="**********" required type="password"
                        v-bind:invalid="!!requestStore.errors?.password_confirmation"
                        v-bind:label="__('Confirm password')"
                        v-model="passwordConfirmation"
        />

        <input name="email" type="hidden" v-model="email" />
        <input name="token" type="hidden" v-model="token" />

        <c-button class="bg-slate-800 border-2 border-slate-800 font-semibold hover:bg-highlight hover:border-highlight mb-4 mt-8 mx-auto normal-case px-4 py-2 rounded-none table text-center !text-lg text-white transition-colors w-48"
                  v-on:click="submit"
        >
            {{ __('Jelszó módosítása') }}
        </c-button>
    </div>
</template>

<script setup lang="ts">
    import { onMounted, ref } from 'vue';
    import { useRoute } from 'vue-router';
    import {
        CButton,
        CControlText,
    } from '@teamfurther/cinderblock';

    import { useRequestStore }  from '../../stores/request';
    import { useSessionStore }  from '../../stores/session';

    const password = ref<string>('');
    const passwordConfirmation = ref<string>('');
    const requestStore = useRequestStore();
    const route = useRoute();
    const sessionStore = useSessionStore();
    const email = route.query.email;
    const token = route.params.token;

    async function submit() {
        await sessionStore.resetPassword(email, password.value, passwordConfirmation.value, token);
    }

    onMounted(() => {
        if (sessionStore.user) {
            requestStore.redirect({ name: 'errors.403' });
        }
    });
</script>
